import React, { useEffect, useState } from 'react'
import { doc, onSnapshot } from 'firebase/firestore'
import { Flex, Heading, Link as ExternalLink } from 'rebass/styled-components'
import axios from 'axios'
import { db } from '../system/firebase/index'
import AnimationWrapper from '../helpers/Animations'
import Spacer from '../components/general/Spacer'
import SwiperInstagram from '../components/swiper/Instagram'

const Instagram = ({ options }) => {
    const [media, setMedia] = useState([])
    const [token, setToken] = useState(false)

     useEffect(() => {
        let isCancelled = false
        onSnapshot(doc(db, 'tokens', 'instagram'), (doc) => {
            if (!isCancelled) {
                const insta = doc.data()
                setToken(insta.access_token)
            }
        })
        return () => {
            isCancelled = true
        }
    },[])

    useEffect(() => {
        let isCancelled = false;
        if (!media.length) {
            axios.get(`https://graph.instagram.com/me/media?fields=id,caption,media_type,media_url,permalink,thumbnail_url&access_token=${token}`)
                .then(function(response) {
                    const { data } = response.data
                    const sanitizedInstagramArray = data.filter(function(item) {
                        return item.media_type === 'CAROUSEL_ALBUM' || item.media_type === 'IMAGE';
                    },
                    );
                    if (!isCancelled) {
                        setMedia(sanitizedInstagramArray)
                    }
                })
                .catch(function(error) {
                    console.log('invalid token')
                })
        }
        return () => {
            isCancelled = true;
        }
    }, [media, token])


    return (
        <AnimationWrapper type='fade-up'>
            <Spacer spacing={options.spacing}>
                <Flex justifyContent="center">
                    <Heading
                        as="h2"
                        variant="h3"
                        pb="md"
                        sx={{
                            textTransform: 'uppercase',
                        }}>Follow <ExternalLink href="https://www.instagram.com/kidstonmotorcars/" target="_blank" sx={{
                            color: 'black',
                            textDecoration: 'none',
                        }}>@kidstonmotorcars</ExternalLink></Heading>
                </Flex>
                <SwiperInstagram slides={media} />
            </Spacer>
        </AnimationWrapper>
    )
}
export default Instagram
